// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";

const ApprovalPenerimaanBarangPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    PurchaseOrderID: "",
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const [showModalTolak, setShowModalTolak] = useState(false);
  const [keteranganTolak, setKeteranganTolak] = useState("");
  const param = useLocation();

  // Klik baris → buka modal edit baris tsb (cari indexnya via GoodsAcceptanceListID).
  const ModalOpener = (rowDetail) => {
    const idx = detail.findIndex(
      (d) => d.GoodsAcceptanceListID === rowDetail.GoodsAcceptanceListID
    );
    if (idx !== -1) ModalEdit(rowDetail, idx);
  };

  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/GoodsAcceptance/one/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/GoodsAcceptance/approval", formData)
  );
  const po = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/min/U")
  );
//   const detailPO = useMutation((formData) =>
//     fetchGet("Procurement/PurchaseOrder/warehouse/" + formData)
//   );

 const detailPO = useMutation((purchaseOrderID) =>
    fetchGet(
      `Procurement/PurchaseOrder/warehouse/${purchaseOrderID}?BisnisUnitID=${values.BisnisUnitID}`
    )
);


  const ModalEdit = (row, id) => {
    setModalID(id);
    setModalDetail({ ...row });
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    po.mutate();
    barang.mutate();
    if (param.state) {
      mutationGet.mutate(param.state.GoodsAcceptanceID);
    }
  }, []);

  useEffect(() => {
    detailPO.mutate(values.PurchaseOrderID);
  }, [values.PurchaseOrderID]);

  useEffect(() => {
    if (values.PurchaseOrderID !== "" && detailPO.data) {
      if (!param.state) setDetail(detailPO.data.data);
    }
  }, [detailPO.data]);

  useEffect(() => {
    if (mutationUpdate.isSuccess) {
      toast.success("Berhasil diproses", { autoClose: 1500 });
      setTimeout(() => navigate("/approval-list"), 1600);
    }
    if (mutationUpdate.isError) {
      toast.error("Gagal memproses, silahkan coba lagi");
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationGet.data) {
      let temp = mutationGet.data.data;
      temp["BisnisUnitID"] = param.state.BisnisUnitID;

      setDetail(temp["Data"]);
      blastChange(mutationGet.data.data);
    }
  }, [mutationGet.status]);


  useEffect(() => {
    if (values.PurchaseOrderID !== "" && detailPO.data) {
        console.log("Detail PO Data:", detailPO.data.data);
        console.log("Sample item with SaldoAkhir:", detailPO.data.data[0]);
        if (!param.state) setDetail(detailPO.data.data);
    }
}, [detailPO.data]);

useEffect(() => {
    if (mutationGet.data) {
        let temp = mutationGet.data.data;
        temp["BisnisUnitID"] = param.state.BisnisUnitID;

        console.log("Mutation Get Data - Data array:", temp["Data"]);
        console.log("First item SaldoAkhir:", temp["Data"][0]?.SaldoAkhir);
        
        setDetail(temp["Data"]);
        blastChange(mutationGet.data.data);
    }
}, [mutationGet.status]);

 const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    {
        name: "Stok Akhir",
        key: "SaldoAkhir",
        modifiers: "number",
        render: (item) => item.SaldoAkhir ?? 0 // Fallback ke 0 jika undefined/null
    },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Qty PO", key: "Qty", modifiers: "number" },
    { name: "Qty Terima", key: "QtyMasuk", modifiers: "number" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "Text" },
    // Tombol Edit membuka modal koreksi Qty Terima — pola sama dgn halaman
    // form-penerimaan-barang-add. Hanya muncul saat mode approval nyata
    // (baris punya GoodsAcceptanceListID); di mode PO manual disembunyikan.
    ...(param.state
      ? [{ name: "Aksi", key: "EditDelete", modifiers: "Edit" }]
      : []),
];

  // Batas maksimum Qty Terima untuk satu baris = sisa yang belum diterima di PO
  // (QtyBelum, sudah memperhitungkan GA lain) DITAMBAH qty yang saat ini diklaim
  // GA ini. Sebab QtyBelum dari backend sudah mengurangi qty GA ini, jadi untuk
  // mendapat plafon sebenarnya kita kembalikan dulu qty GA ini.
  const maksQtyTerima = (row) => {
    const belum = parseFloat(row.QtyBelum) || 0;
    const qtyIni = parseFloat(row.QtyMasuk) || 0;
    const maks = belum + qtyIni;
    return maks > 0 ? maks : 0;
  };

  // Perubahan Qty Terima di modal, dengan validasi minus & plafon.
  const modalHandlerText = (event) => {
    const { name, value } = event.target;
    if (name !== "QtyMasuk") {
      setModalDetail((prev) => ({ ...prev, [name]: value }));
      return;
    }
    if (value.startsWith("-")) {
      toast.error("Qty Terima tidak boleh bernilai minus");
      return;
    }
    const qtyMasuk = parseFloat(value) || 0;
    const maks = maksQtyTerima(modalDetail);
    if (qtyMasuk > maks) {
      toast.error(`Qty Terima tidak boleh lebih dari ${maks}`);
      return;
    }
    setModalDetail((prev) => ({ ...prev, QtyMasuk: value }));
  };

  const inputBuilder = [
    { type: "Barang", name: "BarangID", title: "Barang", disabled: true },
    { type: "number", name: "Qty", title: "Qty PO", disabled: true },
    { type: "number", name: "QtyBelum", title: "Qty Belum Diterima", disabled: true },
    { type: "number", name: "QtyMasuk", title: "Qty Terima", disabled: false },
    { type: "text", name: "KeteranganDetail", title: "Keterangan", disabled: false },
  ];

  const handleModalSubmit = () => {
    const qtyMasuk = parseFloat(modalDetail.QtyMasuk) || 0;
    const maks = maksQtyTerima(modalDetail);
    if (qtyMasuk < 0) {
      toast.error("Qty Terima tidak boleh minus");
      return;
    }
    if (qtyMasuk > maks) {
      toast.error(`Qty Terima tidak boleh lebih dari ${maks}`);
      return;
    }
    setDetail((prev) =>
      prev.map((row, i) => (i === modalID ? { ...modalDetail } : row))
    );
    setShowModal(false);
    setShowModalEdit(false);
    toast.success("Qty Terima diperbarui");
  };
  const Kirim = (type, alasan = "") => {
    mutationUpdate.mutate({
      GoodsAcceptanceID: param.state.GoodsAcceptanceID,
      Approved: type,
      KeteranganTolak: alasan,
      ...values,
      // Qty Terima hasil koreksi approver. Hanya baris ber-GoodsAcceptanceListID
      // (mode approval nyata) yang dikirim; backend memakainya untuk update
      // GoodsAcceptanceList.Qty sebelum menghitung stok & jurnal.
      Data: detail
        .filter((row) => row.GoodsAcceptanceListID)
        .map((row) => ({
          GoodsAcceptanceListID: row.GoodsAcceptanceListID,
          QtyMasuk: row.QtyMasuk,
        })),
    });
  };

  const KonfirmasiTolak = () => {
    if (!keteranganTolak.trim()) {
      toast.warning("Alasan penolakan wajib diisi");
      return;
    }
    setShowModalTolak(false);
    Kirim("2", keteranganTolak);
    setKeteranganTolak("");
  };

  return (
    <div className="md:ml-64">
      <ToastContainer position="top-right" />

      {/* Modal Konfirmasi Tolak */}
      {showModalTolak && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Konfirmasi Penolakan</h2>
            <p className="text-sm text-gray-500 mb-4">
              Penerimaan ini akan ditolak dan tidak dapat diproses ulang. Mohon isi alasan penolakan.
            </p>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-1">
              Alasan Penolakan <span className="text-red-500">*</span>
            </label>
            <textarea
              value={keteranganTolak}
              onChange={(e) => setKeteranganTolak(e.target.value)}
              rows={3}
              placeholder="Tulis alasan penolakan..."
              className="w-full border border-gray-300 rounded px-3 py-2 text-sm text-gray-700 outline-none focus:border-red-400 resize-none"
            />
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => { setShowModalTolak(false); setKeteranganTolak(""); }}
                className="px-4 py-2 text-sm font-semibold text-gray-700 border border-gray-300 rounded hover:bg-gray-100"
              >
                Batal
              </button>
              <button
                onClick={KonfirmasiTolak}
                disabled={mutationUpdate.isLoading}
                className="px-4 py-2 text-sm font-semibold text-white bg-red-500 rounded hover:bg-red-600 disabled:opacity-50"
              >
                {mutationUpdate.isLoading ? "Memproses..." : "Ya, Tolak"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate("/gudang/transaction/penerimaan-barang")
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim("1")}
                    className="bg-green-100 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationUpdate.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Approve"
                    )}
                  </button>
                  <button
                    onClick={() => setShowModalTolak(true)}
                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationUpdate.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Tolak"
                    )}
                  </button>
                </div>

                <>
                  {po.data && po.data.data !== null ? (
                    <div className="w-1/3">
                      <div className={"w-full px-3 mb-6"}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Purchase Order ID *
                        </label>
                        <Select
                          value={po.data.data.filter(
                            ({ value }) => value === values["PurchaseOrderID"]
                          )}
                          isDisabled={true}
                          name={"PurchaseOrderID"}
                          className={
                            (touched["PurchaseOrderID"] || buttonTouched) &&
                            errors["PurchaseOrderID"]
                              ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                              : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                          }
                          onChange={(text) =>
                            customHandler(text.value, "PurchaseOrderID")
                          }
                          options={po.data.data}
                        />

                        {(touched["PurchaseOrderID"] || buttonTouched) &&
                          touched["PurchaseOrderID"] && (
                            <p className="text-red-500 text-xs italic">
                              {errors["PurchaseOrderID"]}
                            </p>
                          )}
                      </div>
                    </div>
                  ) : (
                    <div className={"w-full px-3 mb-6 text-red-800"}>
                      "Tidak ada PO"{" "}
                    </div>
                  )}
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"dateOnly"}
                      value={values}
                      name={"Tanggal"}
                      title={"Tanggal"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"NamaPenerima"}
                      title={"Nama Penerima"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Keterangan"}
                      title={"Keterangan"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                </>

                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={false}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>

            {/* Modal koreksi Qty Terima — pola sama dgn form-penerimaan-barang-add */}
            <Modal size="lg" active={showModal} toggler={() => setShowModal(false)}>
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                Edit Qty Terima
              </ModalHeader>
              <ModalBody>
                <form className="w-full">
                  {inputBuilder.map(({ type, name, title, disabled }, id) => (
                    <HrdInputGenerator
                      key={id}
                      type={type}
                      value={modalDetail}
                      name={name}
                      title={title}
                      onChange={modalHandlerText}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={false}
                      errors={errors}
                      disabled={disabled}
                      barang={barang.data}
                    />
                  ))}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Batal
                </Button>
                <Button color="green" onClick={handleModalSubmit} ripple="light">
                  Ubah
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPenerimaanBarangPage;
